// import components

import mainnav from '@/components/_globals/mainnav/mainnav.vue'

export default {
  name: 'contact',
  components: {
    mainnav
  },
  computed: {
    currentLocale: function () {
      return this.$i18n.locale
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/contact/contact.js